<template>
    <v-container pa-0>
        <v-row v-if="wishlistEntries.length > 0" class="mx-0 mx-sm-n1">
            <v-col
                v-for="(wishlistEntry, index) in wishlistEntries"
                :key="wishlistEntry.id"
                :class="{ 'pr-1': index % 2 === 0, 'pl-1': index % 2 === 1 }"
                class="pa-0 px-sm-1 mb-2"
                cols="6"
                sm="4"
            >
                <wishlist-entry-card
                    :wishlist-entry="wishlistEntry"
                    :account-balance="accountBalance"
                />
            </v-col>
        </v-row>

        <info-card
            v-else
            desc="$vuetify.widgets.wishlist.empty"
            :btn-url="shopUrl"
            btn-text="$vuetify.buttons.reward_shop"
        ></info-card>

        <v-row v-if="moreThenLimit" no-gutters>
            <v-col class="px-7 px-md-0">
                <v-btn
                    class="v-btn--block v-btn--outlined btn-ghost"
                    depressed
                    :to="wishlistUrl"
                >
                    {{
                        $vuetify.lang.t('$vuetify.buttons.all_wishlist_entries')
                    }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
// components
import WishlistEntryCard from '../../components/Cards/WishlistEntry';
import InfoCard from '../../components/Cards/Info';
// models
import { User } from '../../models';
import WishlistEntry from '../../models/WishlistEntry';
// utils
import env from '../../utils/env';
import { ROUTE_SHOP, ROUTE_WISHLIST } from '../../utils/constants';

export default {
    name: 'widget-wishlist',
    components: {
        WishlistEntryCard,
        InfoCard
    },
    computed: {
        wishlistUrl() {
            return { name: ROUTE_WISHLIST };
        },
        shopUrl() {
            return { name: ROUTE_SHOP };
        },
        wishlistEntries() {
            return WishlistEntry.getRandomForWidget();
        },
        moreThenLimit() {
            return (
                WishlistEntry.getAll().length >
                Number(env('dashboard-wishlist-limit'))
            );
        },
        accountBalance() {
            return User.getCurrent().wallet
                ? User.getCurrent().wallet.balance
                : null;
        }
    }
};
</script>
